/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * TechnicianDisplay: customer display component
*/

/* Imports */
import { t } from "i18next";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
/***/

/*
* TechnicianDisplay: customer display component
* Used to display a customer entity
*/

export interface TechnicianDisplayProps extends GenericDisplayProps {
  technician?: EasyTech.Technician
}

class TechnicianDisplay extends GenericDisplay<TechnicianDisplayProps> {
  getLabel = (() => {
    if (!this.props.technician) {
      return t("technician:none");
    }

    return `${this.props.technician.firstName || ""} ${this.props.technician.lastName || ""}`.trim();
  });

  getData = (() => {
    return this.props.technician ? (<>
      <span className="block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
        {this.props.technician.firstName}
        <span className={`${this.props.variant !== "light" && "text-gray-500"}`}> { this.props.technician.lastName }</span>
      </span>
    </>) : (
      <>{t("technician:none")}</>
    );
  });

  getTooltip = (() => this.getLabel());
}

export default TechnicianDisplay;
/***/
